import { User } from "../core/types";
import type { TranslateFn } from "../contexts/TranslationContext";

const TIME_UNITS = [
  { label: "minute", value: 60 },
  { label: "hour", value: 60 * 60 },
  { label: "day", value: 60 * 60 * 24 }
];

export const getResponseTimeTranslation = (translate: TranslateFn, responseTime: number): string => {
  const time = TIME_UNITS.map(unit => Math.floor(responseTime / unit.value));
  const [minutes, hours, days] = time;

  if (minutes < 1) {
    return translate("average_response_time_under_a_minute");
  } else if (minutes < 60) {
    return translate(minutes === 1 ? "average_response_time_1_min" : "average_response_time_x_mins", { count: minutes });
  } else if (hours < 24) {
    return translate(hours === 1 ? "average_response_time_1_hour" : "average_response_time_x_hours", { count: hours });
  } else {
    return translate(days === 1 ? "average_response_time_1_day" : "average_response_time_x_days", { count: days });
  }
};

export const getSupportAgentCanJoinInTranslation = (translate: TranslateFn, supportAgent: User, responseTime: number): string => {
  const time = TIME_UNITS.map(unit => Math.floor(responseTime / unit.value));
  const [minutes, hours, days] = time;
  const agentName = getSupportAgentNameTranslation(translate, supportAgent);

  if (minutes < 1) {
    return translate("support_agent_can_join_under_a_minute", { support_agent: agentName });
  } else if (minutes === 1) {
    return translate("support_agent_can_join_1_min", { support_agent: agentName });
  } else if (minutes < 60) {
    return translate("support_agent_can_join_x_mins", { support_agent: agentName, count: minutes });
  } else if (hours === 1) {
    return translate("support_agent_can_join_1_hour", { support_agent: agentName });
  } else if (hours < 24) {
    return translate("support_agent_can_join_x_hours", { support_agent: agentName, count: hours });
  } else if (days === 1) {
    return translate("support_agent_can_join_1_day", { support_agent: agentName });
  } else {
    return translate("support_agent_can_join_x_days", { support_agent: agentName, count: days });
  }
};

export const getSupportAgentNameTranslation = (translate: TranslateFn, supportAgent: User): string => {
  return supportAgent.first_name || translate("support_agent");
};
